import { Buffer } from 'buffer';

// Polyfill Buffer for browser environment (required by Solana libraries)
(window as any).Buffer = Buffer;
